import { render } from "./FormStat.vue?vue&type=template&id=2c03666a&scoped=true"
import script from "./FormStat.vue?vue&type=script&lang=js"
export * from "./FormStat.vue?vue&type=script&lang=js"

import "./FormStat.vue?vue&type=style&index=0&id=2c03666a&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c03666a"]])

export default __exports__